import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';

export const ActionsRoute: React.FC = () => {
  const theme = useTheme();
  return (
    <ThemeProvider theme={theme}>
      <ActionContainer>
        <Outlet />
      </ActionContainer>
    </ThemeProvider>
  );
};

const ActionContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  display: flex;
  height: 100dvh;
  overflow: auto;
  width: 100%;
`;

export default ActionsRoute;
